// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const UpdateMachineStatusHistory = t.struct({
    changedBy: t.maybe(t.String),
    changedByName: t.maybe(t.String),
    changedOn: t.maybe(t.Number),
    createdBy: t.maybe(t.String),
    createdByName: t.maybe(t.String),
    creationDate: t.maybe(t.Number),
    currentDealerId: t.maybe(t.String),
    currentDealerName: t.maybe(t.String),
    days: t.maybe(t.Number),
    dealerComments: t.maybe(t.String),
    deereRemarks: t.maybe(t.String),
    machineStatus: t.maybe(t.String),
    model: t.maybe(t.String),
    pin: t.maybe(t.String),
    processingStatus: t.maybe(t.String),
    statusText: t.maybe(t.String)
}, {
    name: 'UpdateMachineStatusHistory',
    strict: true
});

export const getDefaultState = () => new UpdateMachineStatusHistory({});

export default UpdateMachineStatusHistory;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/update-machine-status-history.js